import { render } from "./TitleMessageModal.vue?vue&type=template&id=dab7a1ee"
import script from "./TitleMessageModal.vue?vue&type=script&lang=js"
export * from "./TitleMessageModal.vue?vue&type=script&lang=js"
script.render = render

export default script